import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/tick.svg';
import { Icon } from '../Icon/Icon';
export const TickIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
